export default {
  title: 'Pagar con PayPal',
  error: 'El pago con PayPal no pudo completarse. Inténtalo de nuevo.',
};
